<template>
  <div ref="rootRef" :class="{ 'filtros-landing': landing }">
    <!-- Desktop  -->

    <div
      v-if="filtrosDisponibles.length > 0 || filtrosAplicados.length > 0"
      ref="dropdownRef"
      class="filtros-dropdown dropdown d-none d-lg-block">
      <div v-if="filtrosDisponibles.length === 0" class="button-filtro-disabled-container">
        <MyGocuButton
          secondary
          disabled
          :prefix-icon="filtroIcon"
          :label="titulo"
          additional-class="filtros-desktop-trigger user-select-none" />
        <span class="tooltip-message">{{ $t('alojamiento.filtros.todosFiltrosAplicados') }}</span>
      </div>
      <MyGocuButton
        v-else
        dropdown
        secondary
        :prefix-icon="filtroIcon"
        :label="titulo"
        additional-class="filtros-desktop-trigger user-select-none" />

      <!-- filtros menu -->
      <ul class="filtros-dropdown-menu dropdown-menu p-2">
        <template v-for="filtro in filtrosDisponibles" :key="filtro.id">
          <template v-if="filtro.tipo === TIPOS_FILTROS.UNICO">
            <li v-for="opcion in filtro.opciones" :key="opcion.id" class="filtro-item">
              <button
                class="dropdown-item padding-x-5 user-select-none d-flex justify-content-between align-items-center text-primary translate"
                @click.stop="
                  applyFiltro({
                    id: opcion.id,
                    idFiltro: filtro.id,
                    tituloFiltro: filtro.titulo,
                    valor: opcion,
                  })
                ">
                {{ opcion.nombre }}
              </button>
            </li>
          </template>
          <li v-else class="filtro-item">
            <button
              class="dropdown-item padding-x-5 user-select-none d-flex justify-content-between align-items-center text-primary"
              @click.stop="setFiltroActivo(filtro.id)">
              {{ filtro.titulo }}
            </button>

            <!-- filtros submenu  -->
            <div
              v-if="filtroActivoId === filtro.id"
              class="subfiltro-item dropdown-menu dropdown-menu-end p-0 show"
              @click.stop>
              <component
                :is="getComponenteFiltro(filtro.tipo)"
                :configuracion-filtro="filtro"
                @selected="applyFiltro" />
            </div>
          </li>
        </template>
      </ul>
    </div>

    <!-- Filtros aplicados -->
    <template v-if="filtrosAplicados.length > 0">
      <div
        v-for="filtroAplicado in filtrosAplicados"
        :key="filtroAplicado.id"
        class="filtro-aplicado d-none d-lg-flex align-items-center text-primary">
        <span v-if="filtros.find(f => f.id === filtroAplicado.idFiltro)?.tipo !== TIPOS_FILTROS.UNICO" class="small">
          {{ filtroAplicado.tituloFiltro }}:
        </span>
        <span class="p medium ms-2 translate">{{ filtroAplicado.valor.nombre }}</span>
        <CustomIcon
          :icon="closeIcon"
          size="14px"
          class="ml-10 pointer"
          @click="removeFiltroAplicado(filtroAplicado.id)" />
      </div>
    </template>

    <!-- Mobile  -->
    <div
      v-if="filtrosDisponibles.length > 0 || filtrosAplicados.length > 0"
      class="d-lg-none d-inline-flex align-items-center align-self-center flex-shrink-0">
      <MyGocuButton
        secondary
        :prefix-icon="filtroIcon"
        :label="titulo"
        additional-class="filtros-mobile-trigger user-select-none"
        @click="openMobileModal" />
    </div>

    <!-- Filtros aplicados  -->
    <div v-if="filtrosAplicados.length > 0" class="filtros-aplicados-mobile d-lg-none">
      <div
        v-for="filtroAplicado in filtrosAplicados"
        :key="filtroAplicado.id"
        class="filtro-aplicado d-flex align-items-center text-primary">
        <span v-if="filtros.find(f => f.id === filtroAplicado.idFiltro)?.tipo !== TIPOS_FILTROS.UNICO" class="small">
          {{ filtroAplicado.tituloFiltro }}:
        </span>
        <span class="p medium ms-2 translate">{{ filtroAplicado.valor.nombre }}</span>
        <CustomIcon
          :icon="closeIcon"
          size="14px"
          class="ml-10 pointer"
          @click="removeFiltroAplicado(filtroAplicado.id)" />
      </div>
    </div>

    <!-- Mobile modal -->
    <teleport to="body">
      <div
        v-if="showMobileModal"
        class="mobile-modal-overlay"
        :class="{ 'filtros-landing': landing }"
        :style="landing ? styleVars : undefined"
        @click="closeMobileModal">
        <div class="mobile-modal" :style="modalStyle" @click.stop>
          <!-- Filtros menu -->
          <div v-if="!filtroActivoId">
            <ul class="filtros-dropdown-menu p-2">
              <template v-for="filtro in filtrosDisponibles" :key="filtro.id">
                <template v-if="filtro.tipo === TIPOS_FILTROS.UNICO">
                  <li v-for="opcion in filtro.opciones" :key="opcion.id" class="filtro-item">
                    <button
                      class="dropdown-item padding-x-5 user-select-none d-flex justify-content-between align-items-center text-primary translate"
                      @click.stop="
                        applyFiltro({
                          id: opcion.id,
                          idFiltro: filtro.id,
                          tituloFiltro: filtro.titulo,
                          valor: opcion,
                        })
                      ">
                      {{ opcion.nombre }}
                    </button>
                  </li>
                </template>
                <li v-else class="filtro-item">
                  <button
                    class="dropdown-item padding-x-5 user-select-none d-flex justify-content-between align-items-center text-primary"
                    @click.stop="setFiltroActivo(filtro.id)">
                    {{ filtro.titulo }}
                  </button>
                </li>
              </template>
            </ul>
          </div>

          <!-- Filtros submenu -->
          <div v-else>
            <div class="subfiltro-mobile">
              <component
                :is="getComponenteFiltro(getFiltroActivo().tipo)"
                :configuracion-filtro="getFiltroActivo()"
                @selected="applyFiltro" />
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeMount, onUnmounted } from 'vue';
  import FiltroOpciones from 'src/modules/viajesGrupos/components/FiltroOpciones.vue';
  import FiltroSliderPrecio from 'src/modules/viajesGrupos/components/FiltroSliderPrecio.vue';
  import FiltroMes from 'src/modules/viajesGrupos/components/FiltroMes.vue';
  import CustomIcon from 'src/components/CustomIcon.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import filtroIcon from 'src/assets/icons/filtro.svg';
  import closeIcon from 'src/assets/icons/cross.svg';
  import { TIPOS_FILTROS } from 'src/helpers/filtrosUtils';

  const props = defineProps({
    titulo: {
      type: String,
      required: true,
    },
    filtros: {
      type: Array,
      required: true,
    },
    landing: {
      type: Boolean,
      default: false,
    },
    styleVars: {
      type: Object,
      default: null,
    },
  });

  const emit = defineEmits(['filtros-aplicados']);

  const filtrosAplicados = ref([]);
  const filtroActivoId = ref(null);
  const dropdownRef = ref(null);
  const rootRef = ref(null);
  const showMobileModal = ref(false);
  const sectionBackground = ref('');

  const modalStyle = computed(() => (sectionBackground.value ? { backgroundColor: sectionBackground.value } : null));

  const componentesFiltro = {
    [TIPOS_FILTROS.OPCIONES]: FiltroOpciones,
    [TIPOS_FILTROS.RANGO]: FiltroSliderPrecio,
    [TIPOS_FILTROS.MES]: FiltroMes,
  };

  const filtrosDisponibles = computed(() => {
    return props.filtros
      .map(filtro => {
        if (filtro.tipo === TIPOS_FILTROS.OPCIONES || filtro.tipo === TIPOS_FILTROS.UNICO) {
          const idsAplicados = new Set(
            filtrosAplicados.value
              .filter(filtroAplicado => filtroAplicado.idFiltro === filtro.id)
              .map(filtroAplicado => filtroAplicado.id)
          );

          return {
            ...filtro,
            opciones: filtro.opciones.filter(option => !idsAplicados.has(option.id)),
          };
        }
        if (filtro.tipo === TIPOS_FILTROS.MES) {
          const idsAplicados = new Set(
            filtrosAplicados.value
              .filter(filtroAplicado => filtroAplicado.idFiltro === filtro.id)
              .map(filtroAplicado => filtroAplicado.id)
          );
          return { ...filtro, idsAplicados };
        }
        return filtro;
      })
      .filter(filtro => {
        if (filtro.tipo === TIPOS_FILTROS.OPCIONES || filtro.tipo === TIPOS_FILTROS.UNICO) {
          return filtro.opciones?.length;
        }
        return true;
      });
  });

  function applyFiltro(filtroSelected) {
    const filtro = props.filtros.find(f => f.id === filtroSelected.idFiltro);

    if (filtro?.tipo === TIPOS_FILTROS.RANGO || filtro?.tipo === TIPOS_FILTROS.UNICO) {
      filtrosAplicados.value = filtrosAplicados.value.filter(
        filtroAplicado => filtroAplicado.idFiltro !== filtroSelected.idFiltro
      );
    }
    resetFiltroActivo();

    if (showMobileModal.value) {
      closeMobileModal();
    } else {
      closeDropdown();
    }

    filtrosAplicados.value.push(filtroSelected);
    emit('filtros-aplicados', filtrosAplicados.value);
  }

  function getComponenteFiltro(tipo) {
    return componentesFiltro[tipo];
  }

  function removeFiltroAplicado(id) {
    filtrosAplicados.value = filtrosAplicados.value.filter(filtroAplicado => filtroAplicado.id !== id);
    emit('filtros-aplicados', filtrosAplicados.value);
  }

  function closeDropdown() {
    const button = dropdownRef.value?.querySelector('[data-bs-toggle="dropdown"]');
    if (button) {
      button.click();
    }
  }

  function setFiltroActivo(id) {
    filtroActivoId.value = id;
  }

  function resetFiltroActivo() {
    filtroActivoId.value = null;
  }

  function getFiltroActivo() {
    return props.filtros.find(filtro => filtro.id === filtroActivoId.value);
  }

  function openMobileModal() {
    showMobileModal.value = true;
    resetFiltroActivo();
    sectionBackground.value = rootRef.value
      ? getComputedStyle(rootRef.value).getPropertyValue('--landing-background-color').trim()
      : '';
  }

  function closeMobileModal() {
    showMobileModal.value = false;
    resetFiltroActivo();
  }

  onBeforeMount(() => {
    if (dropdownRef.value) {
      dropdownRef.value.addEventListener('hide.bs.dropdown', resetFiltroActivo);
    }
  });

  onUnmounted(() => {
    if (dropdownRef.value) {
      dropdownRef.value.removeEventListener('hide.bs.dropdown', resetFiltroActivo);
    }
  });
</script>

<style scoped lang="scss">
  .filtros-dropdown-menu {
    min-width: 100%;
    position: relative;
    box-shadow: 4px 6px 20px 0px rgba(var(--bs-primary-rgb), 0.1), 2px 4px 5px 0px rgba(var(--bs-primary-rgb), 0.1),
      0px 0px 1px 0px rgba(var(--bs-primary-rgb), 0.1) !important;
    border-radius: var(--bs-border-radius-sm) !important;
    padding: 10px 10px !important;
  }

  ul {
    @media screen and (max-width: 768px) {
      margin-bottom: 0 !important;
    }
  }

  .filtro-item {
    position: static;

    @media screen and (max-width: 768px) {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .subfiltro-item {
    position: absolute !important;
    top: 0 !important;
    left: calc(100% + 2px) !important;
    min-width: 200px !important;
  }

  .subfiltro-mobile {
    min-width: 200px !important;
  }

  .dropdown-item {
    &:active {
      background-color: rgba(var(--bs-primary-rgb), 0.1);
    }

    &:focus {
      background-color: rgba(var(--bs-primary-rgb), 0.1);
    }
  }

  .filtros-dropdown {
    :deep([aria-expanded='true'] .mg-btn-icon--prefix) {
      transform: rotate(180deg);
    }

    :deep(.filtros-desktop-trigger .mg-btn-icon--prefix) {
      transition: transform 0.2s ease;
    }
  }

  .button-filtro-disabled-container {
    position: relative;
    display: inline-block;
  }

  .button-filtro-disabled-container:hover .tooltip-message {
    visibility: visible;
    opacity: 1;
  }

  .tooltip-message {
    visibility: hidden;
    background-color: var(--bs-primary);
    color: var(--bs-white);
    padding: 6px 12px;
    border-radius: var(--bs-border-radius);
    font-size: 13px;
    white-space: nowrap;
    position: absolute;
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
    word-wrap: break-word;
    white-space: normal;
    min-width: 270px;

    &::before {
      content: '';
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: transparent var(--bs-primary) transparent transparent;
    }
  }
  .filtro-aplicado {
    background-color: rgba(var(--bs-primary-rgb), 0.1);
    border-radius: var(--bs-border-radius-xl);
    padding: 6px 14px;
    height: 27px;
    white-space: nowrap;
  }

  .padding-x-5 {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .filtros-aplicados-mobile {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    flex-basis: 100%;
    margin-top: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .mobile-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--bs-primary-rgb), 0.5);
    z-index: 1050;
    display: flex;
    align-items: flex-end;
  }

  .mobile-modal {
    width: 100%;
    background-color: var(--bs-white);
    border-radius: var(--bs-border-radius-lg) var(--bs-border-radius-lg) 0 0;
    max-height: 70vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .filtros-landing {
    :deep(.dropdown-item.text-primary) {
      color: var(--landing-text-color, var(--bs-primary)) !important;
    }

    .dropdown-item {
      &:active,
      &:focus {
        background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1);
      }
    }

    .filtros-dropdown-menu {
      background-color: var(--landing-background-color, var(--bs-white));
      box-shadow: 4px 6px 20px 0px rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1),
        2px 4px 5px 0px rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1),
        0px 0px 1px 0px rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1) !important;
    }

    .filtro-aplicado {
      background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1);

      &.text-primary {
        color: var(--landing-text-color, var(--bs-primary)) !important;
      }
    }

    .tooltip-message {
      background-color: var(--landing-text-color, var(--bs-primary));

      &::before {
        border-color: transparent var(--landing-text-color, var(--bs-primary)) transparent transparent;
      }
    }

    &.mobile-modal-overlay {
      background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.5);
    }
  }
</style>
